<div class="mg-lateral">
  <header class="mg-lateral__intro"><p>Uma capacidade a cada órbita</p><h3>O que você está<br>construindo.</h3><span>Explore uma conquista para descobrir o caminho até ela.</span></header>
  <ul class="mg-lateral__medalhas">
    @for (fase of FASES; track fase.numero) {
      <li><button type="button" class="mg-lateral__medalha" [class.mg-lateral__medalha--obtida]="obtida(fase.numero)" [attr.data-conquista]="fase.numero" (click)="selecionar.emit(fase.numero)">
        <span class="mg-lateral__hexagono" aria-hidden="true">{{ obtida(fase.numero) ? '✓' : '0' + fase.numero }}</span>
        <span class="mg-lateral__conquista">{{ fase.conquista }}</span>
        <span class="mg-lateral__estado">{{ obtida(fase.numero) ? 'Conquistada' : resumo(fase.numero) }}</span>
        @if (novas(fase.numero)) {<span class="mg-lateral__nova">Novo avanço</span>}
      </button></li>
    }
  </ul>
  <details class="mg-lateral__saude"><summary>Como estão os seus números <span aria-hidden="true">+</span></summary><p class="mg-lateral__explicacao">As conquistas registram seu avanço. Estes indicadores ajudam a manter a rotina em dia.</p>
    @for (sinal of sinais; track sinal.entrada.id) {
      @if (sinal.missao.disponivel && sinal.missao.estado !== 'nao_se_aplica') {
        <div class="mg-lateral__sinal" [class.mg-lateral__sinal--atencao]="sinal.missao.estado === 'atencao'">
          <label [for]="'mg-sinal-' + sinal.entrada.id">{{ sinal.entrada.titulo }}</label>
          <progress [id]="'mg-sinal-' + sinal.entrada.id" class="mg-lateral__barra" [value]="sinal.missao.numerador" [max]="sinal.missao.denominador || 1"></progress>
          <span>{{ sinal.missao.numerador }} de {{ sinal.missao.denominador }} {{ sinal.entrada.unidade }}{{ sinal.missao.estado === 'atencao' ? ' · merece atenção' : '' }}</span>
        </div>
      }
    }
  </details>
</div>
